import { baseBUCGet } from '../base/baseBUC';

export const apartmentUserModelGet = ({ buildingId = '', apartmentId = '', userId = '', createdUserId = '', }) => {
    return {
        apartmentId: apartmentId,
        createdUserId: createdUserId,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    };
};